import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter, FaSnapchat, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/images/weblogo1.png"

export default function SocialComponent() {

  return (

    <>

      {/* Footer */}
      <footer className="footer  border-top py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-3">
              <img
                src={logo}
                alt="BioSurge Logo"
                className="mb-3 brand-logo"
                width="160"
                loading="lazy"
              />

              <p className="text-muted bold">Clean Energy. Herbal Power.
                <br />
                Our products are herbal wellness supplements and not medicines.
                <br /><br/>
                Business Name: BioSurge
                <br />
                Email: biosurge01@gmail.com
                <br />
                Phone: +91 7992151205
                <br />
Support hours: Mon–Sat 10am–6pm
                <br />
                Address: Hariomnagar, Aligarh Uttarpradesh - 202002
               {/* house no. 27, 1st floor, */}
                <br />
                Country: India
              </p>

            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-4">
                  <h6 className=" fw-bold">ABOUT</h6>
                  <ul className="list-unstyled">
                    <li><a href="/about-us" className="text-dark bold">ABOUT US</a></li>
                    <li><a href="/blog" className="text-dark bold">BLOG</a></li>
                    <li><a href="/lookbook" className="text-dark bold">LOOK BOOK</a></li>
                  </ul>
                </div>
                <div className="col-4">
                  <h6 className=" fw-bold">SUPPORT</h6>
                  <ul className="list-unstyled">
                    <li><a href="/contact" className="text-dark bold">CONTACT</a></li>
                    <li><a href="/return-policy" className="text-dark bold">RETURN & REFUND POLICY</a></li>

                  </ul>
                </div>
                <div className="col-4">
                  <h6 className=" fw-bold">LEGAL</h6>
                  <ul className="list-unstyled">
                    <li><a href="/privacy-policy" className="text-dark bold">PRIVACY POLICY</a></li>
                    <li><a href="/terms-and-conditions" className="text-dark bold">TERMS & CONDITIONS</a></li>
                    <li><a href="/shipping-policy" className="text-dark bold">SHIPPING POLICY</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <div className="mb-2">
              <a href="https://www.facebook.com/profile.php?id=61588395567640" target="_blank" rel="noopener noreferrer" className="text-dark me-3">
                <FaFacebookF size={20} />
              </a>
              <a href="https://www.instagram.com/biosurge01" target="_blank" rel="noopener noreferrer" className="text-dark me-3">
                <FaInstagram size={20} />
              </a>
              <a href="https://api.whatsapp.com/send/?phone=917992151205&text=Hi+BioSurge%21+I+am+interested+in+your+products.+Can+you+help+me+with+the+order%3F&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="text-dark me-3">
                <FaWhatsapp size={20} />
              </a>
              <a href="https://x.com/BioSurge" target="_blank" rel="noopener noreferrer" className="text-dark me-3">
                <FaTwitter size={20} />
              </a>

            </div>
            <p className="small text-muted">
              © {new Date().getFullYear()} BioSurge. All rights reserved
            </p>
          </div>
        </div>
      </footer>

    </>

  );
}